export class Header {
    DealerName: any;
    DealerSEName : any;
    VisitCount : number;
    MonthName : any;
    MonthYear : any;
}